export default __webpack_public_path__ + "static/media/arr.3a898396.svg";